export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7febc2242748fded674e0dbe1f53d4a784a5d9de41&name=fetchTypeahead!'